import React, { Component } from 'react';
import { Row, Col, Container } from 'react-bootstrap';

class Products extends Component {
    render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h2 className="h4 mt-4 text-black text-uppercase">Products</h2>
                        <hr />
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default Products;